var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77667 3.26479V14.4081L6.29898 12.6496L5.85815 12.4292L5.41732 12.6496L1.93963 14.4081V3.26479H9.77667ZM9.77667 2.28516H1.93963C1.67982 2.28516 1.43064 2.38837 1.24693 2.57208C1.06321 2.7558 0.959999 3.00497 0.959999 3.26479V16L5.85815 13.5509L10.7563 16V3.26479C10.7563 3.00497 10.6531 2.7558 10.4694 2.57208C10.2857 2.38837 10.0365 2.28516 9.77667 2.28516Z",
    fill: "#450A0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0607 12.1229V0.97963H4.22369H3.24406C3.24406 0.719816 3.34727 0.470643 3.53099 0.286927C3.7147 0.103211 3.96388 0 4.22369 0H12.0607C12.3205 0 12.5697 0.103211 12.7534 0.286927C12.9372 0.470643 13.0404 0.719816 13.0404 0.97963V13.7148L12.0607 12.1229Z",
    fill: "#450A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiBookmark);
export default __webpack_public_path__ + "static/media/multi-bookmark.708eac17e453e8d5cce0290890124ddd.svg";
export { ForwardRef as ReactComponent };